import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import {
  AnnotationData,
  CURRENT_ANNOTATION_SCHEMA_VERSION,
  Annotations,
  InvalidAnnotationsError,
} from "@/shared/components/Annotations/schema";
import { schemaValidator } from "@/shared/SchemaValidator";

import { FileRecord } from "../FileRecord";

export function useAnnotationData(fileRecord: FileRecord | undefined) {
  const { files } = useDomainServices();

  return useQuery<Annotations, Error>({
    queryKey: ["annotationData", fileRecord?.file_id],
    queryFn: async ({ signal }) => {
      if (fileRecord === undefined) {
        return Promise.reject(new Error("Invalid fileRecord"));
      }

      const data = await files.getJsonFileContents<Annotations>(
        fileRecord.file_id,
        {
          abortSignal: signal,
        },
      );

      const areValidAnnotations = schemaValidator.validate<AnnotationData>(
        CURRENT_ANNOTATION_SCHEMA_VERSION,
        data,
      );

      if (!areValidAnnotations) {
        const message = `Invalid annotations for file: "${fileRecord.relative_path}" with validation errors: "${JSON.stringify(schemaValidator.errors)}"`;
        throw new InvalidAnnotationsError(message);
      }

      return data;
    },
    enabled: fileRecord !== undefined,
  });
}
